export default {
  name: 'asset-management',
  translationKey: 'asset-management-module',
  routePrefix: 'asset-management',
  routeNamePrefix: 'admin.asset-management',
  directRoutesAvailable: false,
}
